import { resources } from "@constants/hardcoded-strings";
import { formatPolicyComponent } from "@formatters/policy-component-details/policy-component-details-formatter";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { setPolicyComponentDetails, setPolicyComponentDetailsLoading } from "@redux/actions/policy-component-details-actions";
import { getDeployedPolicyComponentRequest } from "@requests/service-configuration";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";

export const getPolicyComponentDetailsReduxRequest = (dispatch: Dispatch) => async (
    policyComponentId: string,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): Promise<PolicyComponent> => {
    dispatch(setPolicyComponentDetailsLoading(true));
    const { data, error } = await getDeployedPolicyComponentRequest(policyComponentId);
    if (data) {

        const formattedPolicyComponent = formatPolicyComponent(data, axnAttributeTypeFields);
        dispatch(setPolicyComponentDetails(formattedPolicyComponent));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getPolicyComponent.error.title,
                resources.requests.getPolicyComponent.error.message,
                error
            );
        }

        dispatch(setPolicyComponentDetailsLoading(false));
    }

    return null;

};